import React from 'react';
import './ServiceCard.css';

function ServiceCard({ service, onBookNow }) {
  return (
    <div className="service-card" onClick={onBookNow} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && onBookNow()}>
      <div className="service-image">
        <img src={service.image} alt={service.title} />
      </div>
      <div className="service-content">
        <h3>{service.title}</h3>
        <p className="service-description">{service.description}</p>
        <div className="service-details">
          <span className="service-duration">{service.duration}</span>
          <span className="service-price">${service.price}</span>
        </div>
        <button className="book-now-btn" onClick={(e) => { e.stopPropagation(); onBookNow(); }}>
          BOOK NOW
        </button>
      </div>
    </div>
  );
}

export default ServiceCard;
